export const isArrayContinuous = (array: number[]) => {
  array.sort((a, b) => a - b);
  let isContinuous = true;
  array.forEach((element, i) => {
    if (i > 0 && element - array[i - 1] !== 1) {
      isContinuous = false;
    }
  });
  return isContinuous;
};
